import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ModalPasswordWithPass from '../../ModalPasswordWithPass';
import SelectEmployeeDirectory from '../../../containers/SelectEmployeeDirectory';

import {
  StyledBoxContainer,
  StyledWithholding,
  StyledTitle,
  StyledWithholdingContent,
  StyledBtnContent,
  StyledDropdown,
  StyledLabel,
  StyledButton
} from './style';

const Withholding = ({
  onSelectYear,
  onClickDownload,
  years,
  year,
  modalPassword,
  checkPassword,
  hideModalPassword,
  errorPassword,
  errorDni,
  listManagedUsers,
  employeeSelected,
  setEmployeeSelected,
  roles,
  sendEmail,
  modalRRHH,
  loadingInModal,
  openModalRRHH
}) => (
  <StyledWithholding>
    <StyledBoxContainer className="mb-30">
      <StyledTitle>Certificado de retenciones</StyledTitle>
      {roles.includes('ROLE_ACCESS_RRHH') ? (
        <StyledTitle>{employeeSelected.text}</StyledTitle>
      ) : (
        roles.includes('ROLE_ACCESS_MANAGER') && (
          <>
            <StyledDropdown
              list={listManagedUsers}
              label={employeeSelected.text}
              changeSelect={user => setEmployeeSelected(user)}
            />
          </>
        )
      )}
      {years.length > 0 ? (
        <React.Fragment>
          <StyledWithholdingContent>
            <StyledLabel id="year">Año</StyledLabel>
            <StyledDropdown
              list={years}
              label={year}
              changeSelect={onSelectYear}
              onSelect={onSelectYear}
              ariaLabelledby="year"
            />
          </StyledWithholdingContent>
          <StyledBtnContent>
            <StyledButton secondary onClick={() => onClickDownload()}>
              Descargar
            </StyledButton>
          </StyledBtnContent>
        </React.Fragment>
      ) : (
        <p>No se encontraron certificados de retenciones</p>
      )}
      {roles.includes('ROLE_ACCESS_RRHH') && (
        <>
          <StyledTitle>Gestionar certificados de otros usuarios</StyledTitle>
          <StyledBtnContent>
            <StyledButton secondary onClick={openModalRRHH}>
              SELECCIONAR USUARIO
            </StyledButton>
          </StyledBtnContent>
        </>
      )}
      {modalPassword && (
        <ModalPasswordWithPass
          action={(passwordSelected, nif) =>
            checkPassword(passwordSelected, nif)
          }
          clickCloseIcon={() => hideModalPassword()}
          labelButton={sendEmail && 'Enviar email'}
          errorPassword={errorPassword}
          errorDni={errorDni}
          loadingInModal={loadingInModal}
        />
      )}
    </StyledBoxContainer>
    {roles.includes('ROLE_ACCESS_RRHH') && modalRRHH && (
      <SelectEmployeeDirectory
        setEmployeeSelected={setEmployeeSelected}
        resetRow={modalPassword}
      />
    )}
  </StyledWithholding>
);
Withholding.propTypes = {
  onSelectYear: PropTypes.func,
  onClickDownload: PropTypes.func,
  years: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.string
    })
  ),
  year: PropTypes.string,
  modalPassword: PropTypes.bool,
  loadingInModal: PropTypes.bool,
  checkPassword: PropTypes.func,
  hideModalPassword: PropTypes.func,
  errorPassword: PropTypes.bool,
  errorDni: PropTypes.bool,
  roles: PropTypes.arrayOf(PropTypes.string),
  listManagedUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.string
    })
  ),
  employeeSelected: PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.number
  }),
  setEmployeeSelected: PropTypes.func
};

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(Withholding);
